// Define action types
export const SET_SESSIONS_DATA = 'SET_SESSIONS_DATA';